import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const { isDark } = useTheme();

  return (
    <footer
      className={`text-center py-6 ${className}`}
    >
      <p
        className={`text-sm ${
          isDark ? 'text-slate-500' : 'text-slate-400'
        }`}
      >
        Powered by{' '}
        <a
          href="https://iomergent.com"
          target="_blank"
          rel="noopener noreferrer"
          className={`hover:underline ${
            isDark
              ? 'text-aurora-violet-400 hover:text-aurora-violet-300'
              : 'text-professional-blue-600 hover:text-professional-blue-700'
          }`}
        >
          IOmergent
        </a>
        {' | '}
        <a
          href="https://iomergent.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
          className={`hover:underline ${
            isDark
              ? 'text-aurora-violet-400 hover:text-aurora-violet-300'
              : 'text-professional-blue-600 hover:text-professional-blue-700'
          }`}
        >
          Privacy Policy
        </a>
      </p>
    </footer>
  );
};

export default Footer;
